import { Outlet, useNavigate } from 'react-router-dom';
import _StanLogo from '@/assets/images/stan-logo.svg';
import { createIconElement } from '@/lib';
import { StanButton } from '../core-components/StanButton/StanButton';
import _StanArrowUpRight from '@/assets/icons/ic-arrow-up-right.svg';
/**
 * Auth layout for unauthenticated pages (login, forgot password, reset password)
 * Simple centered layout without sidebar or navbar
 */
const StanLogo = createIconElement(_StanLogo, {
    className: 'size-8',
    removeFill: false,
});
const StanArrowUpRight = createIconElement(_StanArrowUpRight);
export const EmptyLayout = () => {
    const navigate = useNavigate();
    return (
        <div className='bg-canvas flex min-h-svh'>
            <div className='no-scrollbar relative flex w-full flex-col transition-[width] duration-300 ease-in-out'>
                <div className='bg-canvas sticky top-0 z-20 flex max-h-[var(--navbar-height)] justify-between px-4 py-5'>
                    <div className='cursor-pointer' onClick={() => navigate(-1)}>
                        {StanLogo}
                    </div>
                    <div className=''>
                        <StanButton name='back-to-stan-store' variant='link' onClick={() => navigate(-1)}>
                            Back to Stan Store {StanArrowUpRight}
                        </StanButton>
                    </div>
                </div>
                <Outlet />
            </div>
        </div>
    );
};
